module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David L. Balch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("David L. Balch")]), _vm._v(" is professor of New Testament at Pacific Lutheran Theological Seminary, Berkeley, California.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/139Q5X0/tc-custom/9781467454292.jpg?1736222579772",
      "alt": "This image is the cover for the book Eerdmans Commentary on the Bible: Luke"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eerdmans Commentary on the Bible: Luke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This extract from the "), _c('i', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" provides Balch’s introduction to and concise commentary on Luke. The "), _c('i', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(" presents, in nontechnical language, the best of modern scholarship on each book of the Bible, including the Apocrypha. Reader-friendly commentary complements succinct summaries of each section of the text and will be valuable to scholars, students, and general readers."), _c('br'), _vm._v(" "), _c('br'), _vm._v("Rather than attempt a verse-by-verse analysis, these volumes work from larger sense units, highlighting the place of each passage within the overarching biblical story. Commentators focus on the genre of each text—parable, prophetic oracle, legal code, and so on—interpreting within the historical and literary context."), _c('br'), _vm._v(" "), _c('br'), _vm._v("The volumes also address major issues within each biblical book—including the range of possible interpretations—and refer readers to the best resources for further discussions.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0